import path from 'ramda/src/path'

import moduleDescriptions from 'root/src/shared/descriptions/modules'
import modalModuleIdSelector from 'root/src/client/logic/modal/selectors/modalModuleIdSelector'

export default (state, { routeId }) => {
	const modalModuleId = modalModuleIdSelector(state, { routeId })
	return path(
		[modalModuleId, 'modalContent'], moduleDescriptions,
	)
}
